import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-deactivate-package-dialog',
  templateUrl: './deactivate-package-dialog.component.html',
  styleUrls: ['./deactivate-package-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatDialogModule, 
    MatButtonModule,
    MatIconModule
  ]
})
export class DeactivatePackageDialogComponent {

  deactivate: boolean = false;
  deactivateValue = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DeactivatePackageDialogComponent>
  ) { }

  ngOnInit() {
    if (this.data.component === 'Verification Package') {
      if (this.data.verification_package.status_id === 1) {
        this.deactivate = true;
      } else {
        this.deactivate = false;
      }
    }

    if (this.data.component === 'Organization') {
      if (this.data.organization.status_id === 1) {
        this.deactivate = true;
      } else {
        this.deactivate = false;
      }
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(0);
  }

  onConfirmClick(): void {
    if (this.deactivate) {
      this.dialogRef.close(2);
    } else {
      this.dialogRef.close(1);
    }
  }
}